<!--
[configStart]
{
  "polyfill": true,
  "iview": true,
  "pageInfo": {
    "title": "免费视频剪辑 - 一起剪",
    "linkIcon": "${WinInitData/page_info/icon}",
    "keywords": "融媒体解决方案、县级融媒体、县级融媒体解决方案、县级融媒体中心、融媒体平台、融媒体中心、融媒体建设、媒体融合、融媒体产品提供商、融媒体产品、融媒体软件、绩效考核、版权管理、政务服务、小程序开发、直播工具、AI语音、H5制作",
    "description": "ZAKER融媒体平台，基于高性能架构及云服务，为传统媒体与新媒体融合提供“舆情监测、全媒体内容生产、内容审核、多渠道一键分发、绩效考核统计、内容共享及版权管理、大数据分析、全媒体指挥调度、政务服务、营销案例共享、用户管理、广告投放、平台搭建、小程序、数据展示屏”等高度定制化的技术解决方案。",
    "macroSeo": ["index.html/index"]
  }
}
[configEnd]
-->

<template>
  <div class="singup-bg">
    <a class="page-logo"
       :href="index_page"></a>
    <div class="action-group">
      <a :href="register_page"
         class="action-item">注册帐号</a>
    </div>

    <div class="singup-center" style="padding-bottom:32px;">
      <!-- 切换tab -->
      <TabsPane :tablist="tablist"
                v-model="loginType">
        <div class="login-form"
             slot="code">
          <Form ref="loginByCode"
                :model="codeForm"
                :rules="codeFormRules">
            <FormItem prop="mobile">
              <Input placeholder="请输入您的手机号"
                     v-model="codeForm.mobile"
                     @on-enter="handleSubmit">
              <a-icon type="mobile"
                      slot="prepend" />
              </Input>
            </FormItem>

            <FormItem prop="sms_code"
                      class="form-item-expand sms-expand">
              <Input placeholder="请输入短信验证码"
                     v-model="codeForm.sms_code"
                     @on-enter="handleSubmit">
              <a-icon type="safety-certificate"
                      slot="prepend" />
              </Input>
              <button type="button"
                      class="item-expand"
                      :disabled="waitTime < 60"
                      @click="sendSms">{{waitTime < 60 ? waitTime+' s':'获取验证码'}}</button>
            </FormItem>
          </Form>
          <div class="error-message">
            {{codeFormError}}
          </div>
        </div>
        <div class="login-form"
             slot="password">
          <Form ref="loginByPassword"
                :model="passwordForm"
                :rules="passwordFormRules">
            <FormItem prop="username">
              <Input placeholder="请输入您的手机号或邮箱"
                     v-model="passwordForm.username"
                     @on-enter="handleSubmit">
              <a-icon type="mobile"
                      slot="prepend" />
              </Input>
            </FormItem>

            <FormItem prop="password">
              <Input placeholder="请输入您的密码"
                     type="password"
                     v-model="passwordForm.password"
                     @on-enter="handleSubmit">
              <a-icon type="lock"
                      slot="prepend" />
              </Input>
            </FormItem>

            <FormItem prop="captcha"
                      v-if="showCaptcha"
                      class="form-item-expand pic-expand">
              <Input placeholder="请输入图形验证码内容"
                     v-model="passwordForm.captcha">
              <a-icon type="safety-certificate"
                      slot="prepend" />
              </Input>

              <img class="item-expand"
                   :src="passwordCaptchaUrl"
                   @click="getCaptcha">
            </FormItem>
          </Form>

          <div class="error-message">
            {{passwordFormError}}
          </div>
        </div>
      </TabsPane>

      <Button class="submit-btn"
              @click="handleSubmit"
              :disabled="!canSubmit || !agree"
              :loading="loading">{{btnText}}</Button>

      <Checkbox class="agree"
                v-model="agree">
        <div class="agree-text">我已阅读并同意 <a target="_blank"
             href="/pc/public/assets/privacy_policy.pdf">隐私政策</a> 与 <a target="_blank"
             href="/pc/public/assets/use_agreement.pdf">用户使用协议</a></div>
      </Checkbox>

    </div>

    <div class="page-bottom">
      Copyright © 2020 ZAKER.All Rights Reserved
    </div>

    <CaptchaModal v-model="showCaptchaModal"
                  :mobile="codeForm.mobile"
                  @send-success="countdown"></CaptchaModal>
  </div>
</template>

<script>
import { scrollToEle } from "../utils";
import mixin from "../mixins";
import "../mock/index.js";
// import { getCaptchaImg, login } from "../api/login.js";
import { API, request } from "../api/common";
import TabsPane from '../components/tabs-pane'
import AIcon from '../components/a-icon'
import CaptchaModal from '../components/captcha-modal'

const phoneRule = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
const emailRule = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export default {
  components: { TabsPane, AIcon, CaptchaModal },
  mixins: [mixin],
  data () {
    // 自定义验证手机号/邮箱
    const validatePhoneOrMail = (rule, value, callback) => {
      if (phoneRule.test(value) || emailRule.test(value)) {
        callback()
      } else {
        callback(new Error('请输入您的手机号或邮箱'));
      }
    }

    return {
      register_page: window.WinPageData.register_page,
      index_page: window.WinPageData.index_page,
      tablist: [{
        name: 'code',
        label: '验证码登录'
      }, {
        name: 'password',
        label: '密码登录'
      }],
      loginType: 'code', // code-验证码登录  password-密码登录

      codeForm: { // 验证码的form表单
        mobile: "",
        sms_code: "",
        referer: this.$apm.pageData.referer || ""
      },
      passwordForm: { // 密码登录form表单
        username: "",
        password: "",
        referer: this.$apm.pageData.referer || "",
        captcha: "",
        captchaKey: "",
      },

      codeFormRules: { // 短信验证规则
        mobile: [{ required: true, message: "请输入您的手机号", trigger: "change" }, { pattern: phoneRule, message: '请填写正确的手机号码' }],
        sms_code: [{ required: true, message: "请输入短信验证码", trigger: "change" }],
      },
      passwordFormRules: { // 密码表单验证
        username: [
          { required: true, message: "请输入您的手机号或邮箱", trigger: "change" },
          { validator: validatePhoneOrMail, message: "请输入正确的手机号或邮箱", trigger: "change" },
        ],
        password: [
          { required: true, message: "请输入您的密码", trigger: "change" },
          {
            min: 8,
            message: "密码最小长度为8字符",
            trigger: "change"
          },
          {
            max: 20,
            message: "密码最大长度限制为20字符",
            trigger: "change"
          },
        ]
      },

      btnText: "登录",
      loading: false,
      showCaptcha: false,

      passwordCaptchaUrl: '', // 登录表单的图形验证
      smsCaptchaUrl: '', // 短信登录的图形验证

      passwordFormError: '', // 密码登录错误提示
      codeFormError: '', // 短信登录错误提示

      waitTime: 60, // 短信倒计时
      waitInterval: null, // 短信倒计时计时器

      showCaptchaModal: false, // 是否显示弹窗

      agree: true, // 是否同意
    };
  },
  beforeDestroy () {
    clearInterval(this.waitInterval)
  },
  computed: {
    canSubmit () {
      let { loginType, codeForm, passwordForm, passwordFormRules, codeFormRules } = this
      let validate = loginType === 'code' ? codeForm : passwordForm
      let rules = loginType === 'code' ? codeFormRules : passwordFormRules
      let hasEmpty = Object.keys(validate).some(item => {
        // 当前项需要验证，并且为空，那就代表表单还没填完（部分字段不需要验证）
        return validate[item] === '' && rules[item]
      })
      return !hasEmpty
    },
  },
  mounted () {
    let registerUrl = this.register_page
    let referer = this.$apm.pageData.referer
    if (referer && registerUrl.indexOf('referer') === -1) {
      if (registerUrl.indexOf('?') === -1) {
        this.register_page += `?referer=${encodeURIComponent(referer)}`
      } else {
        this.register_page += `&referer=${encodeURIComponent(referer)}`
      }
    }

  },
  methods: {

    addCaptcha () {
      this.showCaptcha = true
      this.passwordFormRules.captcha = [{ required: true, message: "请填写图形验证码", trigger: "change" }]
      this.getCaptcha()
    },

    // 登录
    handleSubmit () {
      const self = this
      let $form = null
      let formData = null
      let submitUrl = ''

      switch (this.loginType) {
        case 'code':
          $form = this.$refs.loginByCode
          formData = this.codeForm
          submitUrl = API.login_by_mobile_api
          break
        case 'password':
          $form = this.$refs.loginByPassword
          formData = this.passwordForm
          submitUrl = API.login_api
          break
      }

      self.passwordFormError = ''
      self.codeFormError = ''
      $form.validate((valid) => {
        if (valid && submitUrl) {
          self.btnText = "登录中..."
          self.loading = true
          request({
            url: submitUrl,
            params: formData,
            type: 'POST'
          }).then(res => {
            self.btnText = "登录成功，跳转中...";
            if (
              self.$apm.config &&
              self.$apm.config.urlParams &&
              self.$apm.config.urlParams.no_jump
            ) {
              self.btnText = "登录成功";
              callback = self.$apm.config.urlParams.callback;
              window.parent.postMessage(callback, "*");
            } else {
              self.$Message.success('登录成功');
              setTimeout(function () {
                window.location.href = res.data.url;
              }, 1000);
            }
          }).catch((err) => {
            self.loading = false
            self.btnText = "登录";
            if (self.loginType === 'password') {
              self.addCaptcha() // 添加图形验证码验证
              self.passwordFormError = err.msg
            } else {
              self.codeFormError = err.msg
            }
          })
        }
      })

    },

    // 获取图形验证码
    getCaptcha () {
      const self = this;
      self.showCaptcha = true;
      request({ url: API.login_captcha_api, type: 'GET' })
        .then(res => {
          if (res.data && res.data.url) {

            if (self.loginType === 'code') {
              self.smsCaptchaUrl = res.data.url.img
              self.codeForm.captchaKey = res.data.url.key
            } else {
              self.passwordCaptchaUrl = res.data.url.img;
              self.passwordForm.captchaKey = res.data.url.key
            }

          } else {
            self.$Message.error("获取验证码异常!");
          }
        })
    },

    // 发送短信验证码
    sendSms () {
      if (this.waitTime < 60) {
        return false
      }
      this.$refs.loginByCode.validateField('mobile', (error) => {
        if (!error) {
          this.showCaptchaModal = true
        }
      })
    },

    // 倒计时
    countdown () {
      this.showCaptcha = false
      if (this.waitTime < 60) {
        return false
      }
      this.waitTime--
      this.waitInterval = setInterval(() => {
        this.waitTime--
        if (this.waitTime <= 0) {
          this.waitTime = 60
          clearInterval(this.waitInterval)
        }
      }, 1000)
    }

  },
};
</script>

<style lang="less">
@import '../assets/css/singUp.less';
</style>



// WEBPACK FOOTER //
// login.vue?3cb0e2b9